export default __webpack_public_path__ + "static/media/popup-4.ea902cce.jpeg";